<template>
  <div class="form-check">
    <input
        class="form-check-input"
        type="checkbox"
        :id="id"
        :checked="isChecked"
        :disabled="disabled"
        @change="handleChange"
    />
    <label class="form-check-label" :for="id">{{ label }}</label>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'CheckboxField',
  props: {
    modelValue: Boolean,
    label: String,
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { id: uuidv4() };
  },
  computed: {
    isChecked() {
      return this.modelValue;
    }
  },
  methods: {
    handleChange(event) {
      if (this.disabled) return;
      this.$emit('update:modelValue', event.target.checked);
    }
  }
};
</script>